export const BLOG_CATEGORIES = [
  'AI & Automation',
  'Web Dev',
  'Cybersecurity',
  'Mobile & Gaming',
  'Company News'
];

export function slugifyHeading(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-');
}